import { createAction } from '@reduxjs/toolkit';

import type { DashboardScope } from '../domain/scope';

/**
 * "Signal" action: the intent the UI dispatches for the saga to act on. Kept out
 * of the slice's reducers: it triggers the eight panel fetches (side effects),
 * not the state transitions (the saga owns the per-panel `*Loaded` / `*Failed`
 * transitions).
 */

/** Load (or reload) every dashboard panel; dispatched by the page on mount. */
export const dashboardRequested = createAction('dashboard/dashboardRequested');

/** The user narrowed (or widened) the page; re-read the scoped panels under it. */
export const scopeRequested = createAction<DashboardScope>('dashboard/scopeRequested');
